import React, { useEffect, useState } from "react";

import Attachment from "../../assets/images/attachment.svg";

import ProbationCircle from "../../assets/images/probationCircle.svg";
import FullTimeCircle from "../../assets/images/fullTimeCircle.svg";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { Form } from "react-bootstrap";
import CompanyPolicyService from "../../services/companyPolicy.service";

import CalendarIcon from "../../assets/images/calendarIcon.svg";

import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";

import moment from "moment";

const EditPolicy = ({ editPolicy, setEditPolicy, policyData, fetchAllPolicies }) => {

  const [validated, setValidated] = useState(false);

  const initialData = {
    id: "",
    title: "",
    description: "",
    attachment: "",
    attchdoc: "",
    applicableFor: "",
    effectiveOn: "",
    formatedDate: "",
  };

  const [details, setDetails] = useState(initialData);

  const [date, setDate] = useState();

  const [showCalendar, setShowCalendar] = useState(false);

  useEffect(() => {
    setDetails({
      id: policyData.id,
      title: policyData.title,
      description: policyData.description,
      attchdoc: policyData.attchdoc,
      applicableFor: policyData.applicableFor && policyData.applicableFor,
      effectiveOn: moment(new Date(policyData.effectiveOn)).format("YYYY-MM-DD"),
      formatedDate: moment(new Date(policyData.effectiveOn)).format("D MMM YYYY"),
    });
  }, [policyData]);

  // console.log("details", details)

  const currentDate = new Date();

  const disableWeekends = ({ date, view }) => {
    // Disable weekends
    if (view === "month") {
      return date.getDay() === 0 || date.getDay() === 6;
    }
  };

  const handleChangeDate = (newValue) => {
    setDate(newValue);
    setDetails({
      ...details,
      effectiveOn: moment(new Date(newValue)).format("YYYY-MM-DD"),
      formatedDate: moment(new Date(newValue)).format("D MMM YYYY"),
    });
    setShowCalendar(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "applicableFor") {
      if (e.target.checked) {
        setDetails({ ...details, [name]: value });
      }
    } else {
      setDetails({ ...details, [name]: value });
    }
  };

  const handleChangeTitle = (e) => {
    const { name, value } = e.target;
    setDetails({ ...details, [name]: value });
  }

  const handleFileChange = (e) => {
    setDetails({ ...details, attachment: e.target.files[0] });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      setValidated(true);
      toast.warn("* Please fill all required fields!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }

    const formData = new FormData();
    formData.append("id", details.id);
    formData.append("title", details.title);
    formData.append("description", details.description);
    formData.append("attachment", details.attachment === undefined ? "" : details.attachment);
    formData.append("attchdoc", details.attchdoc);
    formData.append("applicableFor", details.applicableFor);
    formData.append("effectiveOn", details.effectiveOn);

    // console.log("details", details);

    CompanyPolicyService.updateCompanyPolicy(formData)
      .then((resp) => {
        if (resp.data.errors) {
          toast.warn("Company Policy not Added", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else {
          fetchAllPolicies();
          toast.success("Company Policy Added Successfully", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          
        }
        setEditPolicy(false);
      })
      .catch((e) => console.log(e));
  };

  return (
    <>
      <div
        className={`${
          editPolicy
            ? "add-event feedback policy visible"
            : "add-event feedback policy hidden"
        }`}
      >
        <div className="flex mb-5">
          <div className="left-flex mb-4">
            <span>Update Policy </span>
          </div>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <div className="event-form scroll">
              <div className="mb-3">
                <label htmlFor="" className="form-label">
                  Add Policy Name
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="title"
                  value={details.title || ""}
                  onChange={handleChangeTitle}
                />
              </div>
              <div className="mb-3">
                <label htmlFor="" className="form-label">
                  Add Information/Details about policy
                </label>
                <textarea
                  name="description"
                  value={details.description}
                  onChange={handleChange}
                ></textarea>
              </div>
              <div className="mb-3 calendar-relative">
                <label htmlFor="leaveType" className="form-label">
                  Effective On
                </label>
                <div className="date-input">
                  <span>{details.formatedDate}</span>
                  <span>
                    <img
                      src={CalendarIcon}
                      onClick={(e) => {
                        setShowCalendar(!showCalendar);
                      }}
                      alt=""
                    />
                  </span>
                </div>

                {showCalendar && (
                  <div className="calendarModal2">
                    <div className="heading">
                      <span>Calendar</span>
                    </div>
                    <Calendar
                 
                      tileDisabled={disableWeekends}
                      onChange={handleChangeDate}
                      value={date}
                    />
                  </div>
                )}
              </div>
              <div className="attachment mb-3">
                <span>
                  <input
                    type="file"
                    name="attachment"
                    onChange={handleFileChange}
                  />
                </span>
                <span>
                  <img src={Attachment} alt="" />
                </span>
                <span>Attach Documents</span>
                <small>File Types: pdf, jpeg, png, word </small>
              </div>
              <div className="mb-3">
                <label htmlFor="" className="form-label">
                  This policy is for?
                </label>
                <div className="statusFilter-flex2">
                  <div className="sort-flex">
                    <div className="">
                      <img src={ProbationCircle} alt="" />
                      <span className="status-filter">Probation</span>
                    </div>
                    <label className="checkbox-container">
                      <input
                        type="radio"
                        name="applicableFor"
                        value="0"
                        id="probation"
                        checked={details.applicableFor === 0}
                        onChange={handleChange}
                      />
                      <span className="checkmark"></span>
                    </label>
                  </div>
                  <div className="sort-flex">
                    <div className="">
                      <img src={FullTimeCircle} alt="" />
                      <span className="status-filter">Full Time</span>
                    </div>

                    <label className="checkbox-container">
                      <input
                        type="radio"
                        name="applicableFor"
                        value="1"
                        id="fullTime"
                        checked={details.applicableFor === 1}
                        onChange={handleChange}
                      />
                      <span className="checkmark"></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div className="sort-action">
              <button className="btn btn-reset" onClick={(e) => {setEditPolicy(false)}}>Reset</button>
              <button className="btn btn-apply">Update</button>
            </div>
          </Form>
        </div>
      </div>
    </>
  );
};

export default EditPolicy;
